
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import VuexPersist from 'vuex-persist';
const vuexLocal = new VuexPersist({storage: window.localStorage});

const Helper = {

  state: {
    notif: false,
    notifContent: {},
    settings: false,
    loading: false
  },

  mutations: {

    clearNotif(state){
      state.notif = false;
      state.notifContent = {};
    },

    setNotif(state, notif){
      state.notifContent = notif;
      state.notif = true;
    },

    toggleSettings(state){
      state.settings = state.settings ? false : true;
    },

    loadingActive(state){
      state.loading = true;
    },
    loadingInactive(state){
      state.loading = false;
    }

  },

  actions: {

    initNotif(context, notif){
      context.commit('setNotif', notif);
    },

    dismissNotif(context){
      context.commit('clearNotif');
    },

    togSettings(context){
      context.commit('toggleSettings');
    },

    loadingOn(context){
      context.commit('loadingActive');
    },
    loadingOff(context){
      context.commit('loadingInactive');
    }

  }

}

export default Helper;



// WEBPACK FOOTER //
// ./src/store/helper.js